import styled from 'styled-components/macro';

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 2px;
`;
